import Axios from './axios_wrapper'

export function getTrials(page) {
  return Axios({
    url: '/trials',
    method: 'GET',
    page
  })
}

export function getOpenTrials(page) {
  return Axios({
    url: '/open_trials',
    method: 'GET',
    page
  })
}

export function getTrial(id) {
  return Axios({
    url: `/trials/${id}`,
    method: 'GET'
  })
}

export function createTrial(data) {
  return Axios({
    url: '/trials',
    method: 'POST',
    data
  })
}

export function updateTrial(trialId, data) {
  return Axios({
    url: `/trials/${trialId}`,
    method: 'PATCH',
    data
  })
}

export function getAllTrialSurgeons() {
  return Axios({
    url: `/trial_surgeons/`,
    method: 'GET'
  })
}

export function getTrialSurgeons(trialId) {
  return Axios({
    url: `/trials/${trialId}/surgeons`,
    method: 'GET'
  })
}

export function getTrialsForSurgeon(surgeonId, page) {
  return Axios({
    url: `/surgeons/${surgeonId}/trials`,
    method: 'GET',
    page
  })
}

export function getOpenTrialsForSurgeon(surgeonId, page) {
  return Axios({
    url: `/surgeons/${surgeonId}/open_trials`,
    method: 'GET',
    page
  })
}

export function getTrialResponses(trialId, surgeonId) {
  return Axios({
    url: `/trials/${trialId}/surgeons/${surgeonId}/responses`,
    method: 'GET'
  })
}

export function createTrialPatient(trialId, data) {
  return Axios({
    url: `/trials/${trialId}/patients`,
    method: 'POST',
    data
  })
}

export function deleteTrialPatient(trialId, patientId) {
  return Axios({
    url: `/trials/${trialId}/patients/${patientId}`,
    method: 'DELETE'
  })
}

export function createTrialSurgeon(trialId, data) {
  return Axios({
    url: `/trials/${trialId}/surgeons`,
    method: 'POST',
    data
  })
}

export function deleteTrialSurgeon(trialId, surgeonId) {
  return Axios({
    url: `/trials/${trialId}/surgeons/${surgeonId}`,
    method: 'DELETE'
  })
}

export function closeTrial(trialId) {
  return Axios({
    url: `/trials/${trialId}/close`,
    method: 'PATCH'
  })
}

export function exportTrialCsv(trialId, surgeonId) {
  return Axios({
    url: `/trials/${trialId}/csv/${surgeonId}`,
    method: 'GET'
  })
}

export function adminExportTrialCsv(trialId) {
  return Axios({
    url: `/trials/${trialId}/csv`,
    method: 'GET'
  })
}

export function sendReminder(trialId, data) {
  return Axios({
    url: `/trials/${trialId}/responses`,
    method: 'POST',
    data
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/trials.js
// module id = null
// module chunks = 